var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 4.04C18.0372 4.01698 17.9359 3.95576 17.863 3.86668C17.7901 3.77759 17.7502 3.66609 17.75 3.551V2C17.75 1.46957 17.5393 0.960859 17.1642 0.585786C16.7891 0.210714 16.2804 0 15.75 0L3.25 0C2.45435 0 1.69129 0.31607 1.12868 0.87868C0.566071 1.44129 0.25 2.20435 0.25 3V21C0.25 21.7956 0.566071 22.5587 1.12868 23.1213C1.69129 23.6839 2.45435 24 3.25 24H17.75C18.2804 24 18.7891 23.7893 19.1642 23.4142C19.5393 23.0391 19.75 22.5304 19.75 22V6C19.7501 5.53894 19.5909 5.09201 19.2993 4.73484C19.0078 4.37767 18.6017 4.13221 18.15 4.04ZM3.25 2H15.5C15.5663 2 15.6299 2.02634 15.6768 2.07322C15.7237 2.12011 15.75 2.1837 15.75 2.25V3.75C15.75 3.8163 15.7237 3.87989 15.6768 3.92678C15.6299 3.97366 15.5663 4 15.5 4H3.25C2.98478 4 2.73043 3.89464 2.54289 3.70711C2.35536 3.51957 2.25 3.26522 2.25 3C2.25 2.73478 2.35536 2.48043 2.54289 2.29289C2.73043 2.10536 2.98478 2 3.25 2Z",
    fill: "#31D4C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.a5ad8ecea501a26dd204d165cf2a7663.svg";
export { ForwardRef as ReactComponent };